import { type FC } from 'react';

import { Tabs, Tab, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const TabsContainer = styled(Box)`
    margin-bottom: ${(props) => props.theme.spacing(5)};
`;

const StyledTabs = styled(Tabs)`
    margin-bottom: 16px;
    min-height: 48px;
`;

const StyledTab = styled(Tab)`
    font-size: 18px;
    font-weight: 500;
    text-transform: none;
`;

export enum ConfigTabs {
    BeforeSession = 'beforeSession',
    InSession = 'inSession',
    AfterSession = 'afterSession'
}

type TopLevelTabsProps = {
    activeTab: ConfigTabs;
    onChange: (value: ConfigTabs) => void;
};

const TopLevelTabs: FC<TopLevelTabsProps> = ({ activeTab, onChange }) => {
    const { t } = useTranslation('admin_settings', { useSuspense: false });
    return (
        <TabsContainer>
            <StyledTabs
                value={activeTab}
                onChange={(e, newValue) => onChange(newValue)}
                indicatorColor="primary"
                textColor="primary"
                aria-label={t('admin_settings:configuration.tabs.title')}
                variant="fullWidth"
            >
                <StyledTab
                    label={t('admin_settings:configuration.tabs.before-session.title')}
                    value={ConfigTabs.BeforeSession}
                />
                <StyledTab
                    label={t('admin_settings:configuration.tabs.in-session.title')}
                    value={ConfigTabs.InSession}
                />
                <StyledTab
                    label={t('admin_settings:configuration.tabs.after-session.title')}
                    value={ConfigTabs.AfterSession}
                />
            </StyledTabs>
        </TabsContainer>
    );
};
export default TopLevelTabs;
// This code defines a TopLevelTabs component that renders a set of tabs for navigating between different configuration sections in an admin settings page.
